import { APP_BASE_HREF } from '@angular/common';
import { Directive, ElementRef, inject, Input, Renderer2 } from '@angular/core';

/* eslint-disable @typescript-eslint/no-require-imports */
const assets = <const>{
  'assets/logo-recruitee-by-tellent.png': require(`../../assets/logo-recruitee-by-tellent.png`),
  'assets/recruitee.png': require(`../../assets/recruitee.png`),
  'assets/tellent.png': require(`../../assets/tellent.png`),
  'assets/open-in-new.png': require(`../../assets/open-in-new.png?preset=generic`),
  'assets/upgrade-icon.png': require(`../../assets/upgrade-icon.png`),
  'assets/checkmark.png': require(`../../assets/checkmark.png`),
  'assets/referrals.png': require(`../../assets/referrals.png`),
  'assets/referrals-de.png': require(`../../assets/referrals-DE.png`),
  'assets/referrals-fr.png': require(`../../assets/referrals-FR.png`),
  'assets/warning-icon.png': require(`../../assets/warning-icon.png`),
  'assets/logo-footer-recruitee.png': require(`../../assets/logo-footer-recruitee.png`),
  'assets/logo-footer-kiwihr.png': require(`../../assets/logo-footer-kiwihr.png`),
  'assets/logo-footer-javelo.png': require(`../../assets/logo-footer-javelo.png`),
  'assets/logo-small-ats.png': require('../../assets/logo-small-ats.png'),
  'assets/logo-small-hris.png': require('../../assets/logo-small-hris.png'),
  'assets/logo-tellent-new.png': require('../../assets/logo-tellent-new.png'),
  'assets/logo-recruitee-footer.png': require('../../assets/logo-recruitee-footer.png'),
};

@Directive({
  standalone: true,
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: `img`,
})
export class EmailImageAssetDirective {
  public baseHref = inject(APP_BASE_HREF, { optional: true });
  public renderer = inject(Renderer2);
  public elRef = inject(ElementRef);

  @Input() public src: keyof typeof assets;

  public ngOnChanges() {
    if (this.src.startsWith('http')) {
      this.elRef.nativeElement.src = this.src;
      return;
    }

    const hashedFilename = assets[this.src];

    this.elRef.nativeElement.src = this.baseHref
      ? `${this.baseHref}/${hashedFilename}`
      : hashedFilename;
  }
}
